<script>
import SpellCheckedText from "@/components/SpellCheckedText.vue";
import PhotoBox from "../../PhotoBox.vue";

export default {
  name: "LPTemp3",
  components: {
    SpellCheckedText,
    PhotoBox
  },
  props: ["proposal"]
};
</script>

<template>
  <div class="main-container" :style="{
    '--header-color': proposal.style.colorScheme.header,
    '--body-color': proposal.style.colorScheme.body,
    '--footer-color': proposal.style.colorScheme.footer,
    '--heading-color': proposal.style.heading.color,
    '--heading-size': proposal.style.heading.size + 'px',
    '--heading-font': proposal.style.heading.font,
    '--heading-weight': proposal.style.heading.bold ? 'bold' : 'normal',
    '--heading-style': proposal.style.heading.italic ? 'italic' : 'normal',
    '--heading-decoration': proposal.style.heading.underline
      ? 'underline'
      : 'none',
    '--label-color': proposal.style.label.color,
    '--label-size': proposal.style.label.size + 'px',
    '--label-font': proposal.style.label.font,
    '--label-weight': proposal.style.label.bold ? 'bold' : 'normal',
    '--label-style': proposal.style.label.italic ? 'italic' : 'normal',
    '--label-decoration': proposal.style.label.underline
      ? 'underline'
      : 'none',
    '--text-color': proposal.style.text.color,
    '--text-size': proposal.style.text.size + 'px',
    '--text-font': proposal.style.text.font,
    '--text-weight': proposal.style.text.bold ? 'bold' : 'normal',
    '--text-style': proposal.style.text.italic ? 'italic' : 'normal',
    '--text-decoration': proposal.style.text.underline ? 'underline' : 'none',
  }">
    <div class="lastPage">
      <div class="header-sec">
        <div class="banner top-banner" />
        <div class="logo-sec photobox">
          <PhotoBox v-if="proposal.logo" :project="proposal" type="logo" bgColor="transparent" objectFit="contain" />
        </div>
      </div>
      <div class="info-sec">
        <div class="detail-sec">
          <div class="big-logo-sec photobox">
            <PhotoBox :project="proposal" type="logo" bgColor="transparent" objectFit="contain" />
          </div>
          <p class="name">
            <SpellCheckedText :value="proposal.name || ''" @input="proposal.name = $event" />
          </p>
          <p>
            <SpellCheckedText :value="proposal.address || ''" @input="proposal.address = $event" />
          </p>
          <p>
            <SpellCheckedText :value="proposal.city || ''" @input="proposal.city = $event" />,
            <SpellCheckedText :value="proposal.stateProvince || ''" @input="proposal.stateProvince = $event" />
          </p>
          <p>
            <SpellCheckedText :value="proposal.contactNo || ''" @input="proposal.contactNo = $event" />
          </p>
          <p>
            <SpellCheckedText :value="proposal.email || ''" @input="proposal.email = $event" />
          </p>
          <p>
            <SpellCheckedText :value="proposal.website || ''" @input="proposal.website = $event" />
          </p>
        </div>
        <div class="projects-sec">
          <div v-for="(img, index) in proposal.projects" :key="index">
            <div class="photo-box photobox" v-if="img">
              <PhotoBox :project="img" :bgColor="proposal.style.colorScheme && proposal.style.colorScheme.body" />
            </div>
            <div v-else class="imageBox" />
          </div>
          <div v-if="proposal.projects.length === 1" class="imageBox" />
          <div v-if="proposal.projects.length === 0" class="imageBox" />
          <div v-if="proposal.projects.length === 0" class="imageBox" />
        </div>
      </div>

      <div class="banner bottom-banner" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.main-container {
  display: block;
  width: 211mm;
  height: 296.83mm;
  min-height: 296.83mm;
  position: relative;
  box-sizing: border-box;
  background: white;

  &:hover {
    .photobox :deep(.photo-overlay) {
      opacity: 1;
    }

    .photobox :deep(img) {
      opacity: 0.9;
    }
  }

  .lastPage {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: space-between;
    gap: 60px;
    margin: auto;

    .banner {
      min-height: 80px;

      &.top-banner {
        background: var(--header-color);
      }

      &.bottom-banner {
        background: var(--footer-color);
      }
    }

    .header-sec {
      display: grid;
      grid-template-columns: 3fr 1fr;
      gap: 20px;
      width: 100%;
      margin: 0px;

      .logo-sec {
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--header-color);
        width: 193px;
        height: 80px;
      }
    }

    .info-sec {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 20px;
      padding: 0px 20px;

      .big-logo-sec {
        width: 250px;
        height: 80px;
      }

      .detail-sec {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        background: var(--body-color);
        height: 720px;
        line-height: 1.2;

        .name {
          color: var(--label-color);
          font-size: var(--label-size);
          font-family: var(--label-font);
          font-weight: var(--label-weight);
          font-style: var(--label-style);
          text-decoration: var(--label-decoration);
          margin-bottom: 5px;
        }

        p {
          font-size: 18px;
          margin: 0px;
          color: var(--text-color);
          font-size: var(--text-size);
          font-family: var(--text-font);
          font-weight: var(--text-weight);
          font-style: var(--text-style);
          text-decoration: var(--text-decoration);
        }

        img {
          max-width: 200px;
          height: auto;
          margin-bottom: 20px;
        }
      }

      .projects-sec {
        display: grid;
        grid-template-columns: 1fr;
        gap: 20px;
        background: white;

        .photo-box {
          width: 100%;
          height: 350px;
        }

        .imageBox {
          background: var(--body-color);
          width: 100%;
          height: 350px;
        }
      }
    }


  }
}
</style>